import React from "react";
import Avatar from "../../../Experimental/General/components/Avatar/Avatar";
import {getMentorDynamicImageSrc} from "../MentorDynamicImage/MentorDynamicImage";

export default function MentorAvatar({mentor, ...props}) {
    const profilePhoto = getMentorDynamicImageSrc(mentor.profilePhoto);
    return <Avatar {...props} alt={mentor.firstName || "bot"} dynamic src={profilePhoto} />;
}
